import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const totalContractCostFilterLabel = () => t({
    message: 'Total contract cost',
    comment: 'Insights: Total contract cost filter',
});
export function TotalContractCostFilter() {
    return <NumberRangeFilter name="metadataDocumentTotalContractCost" label={totalContractCostFilterLabel()}/>;
}
